import { cn } from '@/lib/utils';
import { Gender as GenderEnum } from '@/types/enum';
import { useTranslations } from 'next-intl';
import { memo } from 'react';
import { FormControl, FormItem, FormLabel } from '../ui/form';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

type Gender = '0' | '1' | '2';
export type SelectGenderProps = {
    value?: Gender;
    onChange?: (val: Gender) => void;
    disabled?: boolean;
    className?: string;
};

const SelectGender = ({
    disabled,
    onChange,
    value,
    className,
    ...rest
}: SelectGenderProps) => {
    const transDef = useTranslations('System');

    return (
        <RadioGroup
            onValueChange={onChange}
            defaultValue={value}
            value={value}
            className={cn(
                'flex h-10 select-none flex-row gap-3 pb-2',
                className
            )}
            disabled={disabled}
            {...rest}
        >
            <FormItem className='flex items-center space-x-3 space-y-0'>
                <FormControl>
                    <RadioGroupItem value={`${GenderEnum.Male}`} />
                </FormControl>
                <FormLabel className='font-normal cursor-pointer'>
                    {transDef('System_Gender_Male')}
                </FormLabel>
            </FormItem>
            <FormItem className='flex items-center space-x-3 space-y-0'>
                <FormControl>
                    <RadioGroupItem value={`${GenderEnum.Female}`} />
                </FormControl>
                <FormLabel className='font-normal cursor-pointer'>
                    {transDef('System_Gender_Female')}
                </FormLabel>
            </FormItem>
            <FormItem className='flex items-center space-x-3 space-y-0'>
                <FormControl>
                    <RadioGroupItem value={`${GenderEnum.Other}`} />
                </FormControl>
                <FormLabel className='font-normal cursor-pointer'>
                    {transDef('System_Gender_Other')}
                </FormLabel>
            </FormItem>
        </RadioGroup>
    );
};

export default memo(SelectGender);
